function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getEnvironment } from "./getEnvironment.mjs";
export class Driver {
  constructor(logger) {
    _defineProperty(this, "_listeners", []);

    this.logger = logger;
  }

  install() {
    if (window.native) {
      this.logger.log('WARN', 'bridge.driver.install', 'Bridge Modern의 통신 드라이버가 이미 설치되어 있어요.' + ' 기존의 Bridge를 덮어쓰므로 비정상적인 작동이 있을 수 있어요.' + ' Bridge 객체가 여러번 생성되고 있는지 확인해주세요.' + ' (<React.StrictMode />의 영향일 수 있어요.)');
    }

    window.native = this;
    return this;
  }

  uninstall() {
    delete window.native;
  }

  postMessage(message) {
    var _window$AndroidFuncti, _window$webkit;

    switch (getEnvironment()) {
      case 'Android':
        (_window$AndroidFuncti = window.AndroidFunction) === null || _window$AndroidFuncti === void 0 ? void 0 : _window$AndroidFuncti.messageHandler(JSON.stringify(message));
        break;

      case 'Cupertino':
        (_window$webkit = window.webkit) === null || _window$webkit === void 0 ? void 0 : _window$webkit.messageHandlers.messageHandler.postMessage(JSON.stringify(message));
        break;

      case 'Web':
        this.logger.log('WARN', 'bridge.driver.postMessage', 'Bridge Modern의 통신 드라이버는 일반 데스크탑, 모바일 브라우저 환경을 지원하지 않아요.' + ' 현재 Bridge가 생성된 환경이 당근마켓 WebView 환경인지 확인해주세요.');
        break;
    }
  }

  addMessageListener(listener) {
    this._listeners.push(listener);

    const self = this;
    return function dispose() {
      const i = self._listeners.findIndex(l => l === listener);

      self._listeners.splice(i, 1);
    };
  }

  onMessage(message) {
    if (!message) {
      return this.logger.log('ERROR', 'bridge.driver.onMessage', '메시지가 빈 채로 도착했어요');
    }

    this._listeners.map(l => l(message));
  }

}